import React from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'

export const SplitPlanificacionDialog = ({
  splitDialog,
  setSplitDialog,
  salidasProduccion,
  handleSplitPlanificacion,
  guardandoPlanificacion,
  splitTotalPalets,
  splitPaletsPrimera,
  splitPaletsSegunda,
  splitDivisionInvalida,
}) => (
  <Dialog open={Boolean(splitDialog)} onClose={() => setSplitDialog(null)} fullWidth maxWidth="sm">
    <DialogTitle>
      Dividir planificacion
    </DialogTitle>

    <DialogContent>
      {(() => {
        const totalPalets = splitTotalPalets
        const paletsPrimera = splitPaletsPrimera
        const paletsSegunda = splitPaletsSegunda
        const paletsVisuales = Math.min(totalPalets, 80)
        const maxPrimeraParte = Math.max(totalPalets - 1, 1)
        const cambiarPaletsPrimera = (value) => {
          const nuevaCantidad = Math.min(Math.max(Number(value), 1), maxPrimeraParte)

          setSplitDialog((dialog) => ({
            ...dialog,
            cantidadPrimera: nuevaCantidad,
          }))
        }

        return (
          <Box sx={{ display: 'grid', gap: 2, pt: 1 }}>
            <Typography sx={{ color: '#475569', fontSize: '0.88rem' }}>
              Pulsa un palet para elegir cuantos se mantienen en la tarjeta actual. El resto se creara como una segunda planificacion.
            </Typography>

            <Box
              sx={{
                border: '1px solid #DEE6F2',
                borderRadius: '8px',
                backgroundColor: '#F8FAFC',
                p: 1.25,
              }}
            >
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 1, mb: 1 }}>
                <Box>
                  <Typography sx={{ color: '#64748B', fontSize: '0.66rem', fontWeight: 800, textTransform: 'uppercase' }}>
                    Se quedan
                  </Typography>
                  <Typography sx={{ color: '#F57C00', fontWeight: 900, fontSize: '1rem' }}>
                    {paletsPrimera} palets
                  </Typography>
                </Box>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography sx={{ color: '#64748B', fontSize: '0.66rem', fontWeight: 800, textTransform: 'uppercase' }}>
                    Total
                  </Typography>
                  <Typography sx={{ color: '#172033', fontWeight: 900, fontSize: '1rem' }}>
                    {totalPalets} palets
                  </Typography>
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                  <Typography sx={{ color: '#64748B', fontSize: '0.66rem', fontWeight: 800, textTransform: 'uppercase' }}>
                    Se van
                  </Typography>
                  <Typography sx={{ color: '#2563EB', fontWeight: 900, fontSize: '1rem' }}>
                    {paletsSegunda} palets
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${Math.max(paletsVisuales, 1)}, minmax(5px, 1fr))`,
                  gap: 0.35,
                  mt: 1,
                }}
              >
                {Array.from({ length: paletsVisuales }).map((_, index) => {
                  const paletNumero = index + 1
                  const esOriginal = paletNumero <= paletsPrimera

                  return (
                    <Box
                      key={paletNumero}
                      component="button"
                      type="button"
                      onClick={() => cambiarPaletsPrimera(paletNumero)}
                      title={`Palet ${paletNumero}: ${esOriginal ? 'se queda en la tarjeta original' : 'va a la nueva tarjeta'}`}
                      sx={{
                        border: 0,
                        p: 0,
                        cursor: 'pointer',
                        height: 18,
                        borderRadius: '5px',
                        backgroundColor: esOriginal ? '#F57C00' : '#2563EB',
                        opacity: 0.92,
                        outline: paletNumero === paletsPrimera ? '2px solid #172033' : 'none',
                        outlineOffset: 1,
                        transition: 'transform 120ms ease, outline-color 120ms ease',
                        '&:hover': {
                          transform: 'translateY(-1px)',
                        },
                      }}
                    />
                  )
                })}
              </Box>

              {totalPalets > paletsVisuales && (
                <Typography sx={{ mt: 0.7, color: '#64748B', fontSize: '0.72rem', fontWeight: 700 }}>
                  Vista resumida: se muestran {paletsVisuales} bloques de {totalPalets} palets.
                </Typography>
              )}

              <Typography sx={{ mt: 0.9, color: '#334155', fontSize: '0.78rem', fontWeight: 700 }}>
                Quedaran {paletsPrimera} palets en la tarjeta actual y {paletsSegunda} palets pendientes en la nueva tarjeta.
              </Typography>
            </Box>

            <Box>
              <Typography sx={{ color: '#172033', fontWeight: 800, fontSize: '0.78rem', mb: 0.75 }}>
                Maquina destino para la segunda parte
              </Typography>

              <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
                {salidasProduccion
                  .filter((salida) => salida.activa !== false)
                  .map((salida) => {
                    const active = String(splitDialog?.codMaquinaDestino) === String(salida.codMaquina)

                    return (
                      <Button
                        key={salida.codMaquina}
                        size="small"
                        variant={active ? 'contained' : 'outlined'}
                        onClick={() => setSplitDialog((dialog) => ({
                          ...dialog,
                          codMaquinaDestino: salida.codMaquina,
                        }))}
                        sx={{ textTransform: 'none' }}
                      >
                        {salida.desMaquina || `Maquina ${salida.codMaquina}`}
                      </Button>
                    )
                })}
              </Box>
            </Box>
          </Box>
        )
      })()}
    </DialogContent>

    <DialogActions>
      <Button onClick={() => setSplitDialog(null)}>
        Cancelar
      </Button>
      <Button
        variant="contained"
        onClick={handleSplitPlanificacion}
        disabled={guardandoPlanificacion || splitDivisionInvalida}
      >
        Dividir
      </Button>
    </DialogActions>
  </Dialog>
)
